import { announcementsConstants } from "../constants/announcementsConstants";

const initialState = {
  sending: false,
  announcementsResponse: {},
  error: "",
  fetching: "",
  fetchingSites: false,
  announcementsList: {},
  deletedAnnouncements: {},
  updatedAnnouncements: {},
  announcementsData: [],
  fetchAnnouncements: false,
  fetchingAnnouncements: false,
  sendingAnnouncementsData: false,
  announcementsUpdate: {},
  siteList: {}
};

export default function announcementsReducer(state = initialState, action) {
  switch (action.type) {
    case announcementsConstants.ADD_ANNOUNCEMENTS_REQUEST:
      return {
        ...state,
        sendingAnnouncementsData: true
      };
    case announcementsConstants.ADD_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        sendingAnnouncementsData: false,
        announcementsResponse: action.announcements,
        error: ""
      };
    case announcementsConstants.ADD_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        sendingAnnouncementsData: false,
        error: action.error
      };
    case announcementsConstants.FETCH_ANNOUNCEMENTS_REQUEST:
      return {
        ...state,
        fetchingAnnouncements: true
      };
    case announcementsConstants.FETCH_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        fetchingAnnouncements: false,
        announcementsList: action.announcements.data,
        announcementsData: action.announcements.data.data,
        announcementsResponse: {},
        announcementsUpdate: {},
        error: ""
      };
    case announcementsConstants.FETCH_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        fetchingAnnouncements: false,
        error: action.error
      };
    case announcementsConstants.DELETE_ANNOUNCEMENTS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case announcementsConstants.DELETE_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        deletedAnnouncements: action.announcements,
        error: ""
      };
    case announcementsConstants.DELETE_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case announcementsConstants.GET_ANNOUNCEMENTS_DETAILS_REQUEST:
      return {
        ...state,
        fetchAnnouncements: true
      };
    case announcementsConstants.GET_ANNOUNCEMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        fetchAnnouncements: false,
        announcementsDetails: action.announcementsDetails,
        error: ""
      };
    case announcementsConstants.GET_ANNOUNCEMENTS_DETAILS_FAILURE:
      return {
        ...state,
        fetchAnnouncements: false,
        error: action.error
      };
    case announcementsConstants.FETCH_SITELIST_REQUEST:
      return {
        ...state,
        fetchingSites: true
      };
    case announcementsConstants.FETCH_SITELIST_SUCCESS:
      return {
        ...state,
        fetchingSites: false,
        siteList: action.sitelist.data,
        error: ""
      };
    case announcementsConstants.FETCH_SITELIST_FAILURE:
      return {
        ...state,
        fetchingSites: false,
        error: action.error
      };   
    case announcementsConstants.UPDATE_ANNOUNCEMENTS_REQUEST:
      return {
        ...state,
        sendingAnnouncementsData: true
      };
    case announcementsConstants.UPDATE_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        announcementsUpdate: action.updatedAnnouncements,
        sendingAnnouncementsData: false,
        error: ""
      };
    case announcementsConstants.UPDATE_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        error: action.error,
        sendingAnnouncementsData: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/announcementsReducers.js